import React, { FC } from 'react';
import { Col, Row, Form } from 'antd';
import { useTranslate } from '@refinedev/core';
import { Checkbox, FormItem, Textarea } from 'components/ui';
import styles from './steps.module.scss';

interface Step3GeneralInfoProps {
    showApplicationNotes?: boolean;
    applicationNotesLabel?: string;
    showCheckboxes?: boolean;
}

export const Step3GeneralInfo: FC<Step3GeneralInfoProps> = ({
    showApplicationNotes = false,
    applicationNotesLabel,
    showCheckboxes = true,
}) => {
    const t = useTranslate();
    const form = Form.useFormInstance();

    return (
        <div className={styles.stepContainer}>
            <h2 className={styles.stepTitle}>
                {t('preliminary-applications.wizard.step3.title', 'Загальні відомості')}
            </h2>

            <Row gutter={[16, 20]}>
                {showCheckboxes && (
                    <>
                        <Col xs={24}>
                            <FormItem
                                name="is_electronic_form"
                                valuePropName="checked"
                            >
                                <Checkbox
                                    label={t(
                                        'preliminary-applications.fields.electronic_form',
                                        'Подано в електронному вигляді'
                                    )}
                                />
                            </FormItem>
                        </Col>

                        <Col xs={24}>
                            <FormItem name="is_ectd" valuePropName="checked">
                                <Checkbox
                                    label={t(
                                        'preliminary-applications.fields.ectd',
                                        'eCTD'
                                    )}
                                />
                            </FormItem>
                        </Col>

                        <Col xs={24}>
                            <FormItem name="is_mibp" valuePropName="checked">
                                <Checkbox
                                    label={t(
                                        'preliminary-applications.fields.mibp',
                                        'МІВП'
                                    )}
                                />
                            </FormItem>
                        </Col>
                    </>
                )}

                {showApplicationNotes && (
                    <Col xs={24}>
                        <FormItem name="application_notes">
                            <Textarea
                                label={
                                    applicationNotesLabel ??
                                    t(
                                        'preliminary-applications.fields.application_notes',
                                        'Примітки до заявки'
                                    )
                                }
                            />
                        </FormItem>
                    </Col>
                )}
            </Row>
        </div>
    );
};
